import React, { useMemo } from 'react';
import qs from 'query-string';
import useAnalytics from '~/react-hooks/use-analytics';
import { BILLING_SEE_ALL } from '~/generated/AnalyticsTypes';
import { Button } from '@vimily/bonjoro-ui-components-v2/Button';
import cx from 'classnames';
import { Service } from '~/types/models';

export enum ElementType {
  Button = 'button',
  Span = 'span',
}

interface SeeAllInclusionsLinkProps {
  className?: string;
  trackingContext?: string;
  elementType?: ElementType;
  service?: Service;
}

const SeeAllInclusionsLink = ({
  className = '',
  trackingContext,
  elementType = ElementType.Button,
  service = Service.VideoMessaging,
}: SeeAllInclusionsLinkProps) => {
  const analytics = useAnalytics();

  function handleClick() {
    analytics.track(BILLING_SEE_ALL, {
      context: trackingContext,
    });
  }

  const pricingUrl = useMemo(() => {
    if (service === Service.VideoMessaging) {
      const queryParams = qs.stringify({
        plan: 'pro',
      });
      return `${window.Bonjoro.bonjoroPricingPageUrl}?${queryParams}`;
    } else if (service === Service.Testimonials) {
      return window.Bonjoro.bonjoroTestimonialsPricingPageUrl;
    }

    return '/pricing';
  }, [service]);

  return (
    <a
      className={`ml-0 lg:ml-auto ${className}`}
      href={pricingUrl}
      target='_blank'
      rel='noreferrer'
      onClick={handleClick}
    >
      {elementType === ElementType.Button && (
        <Button
          variant='secondary'
          className='v2-text-neutral-900 w-full !py-2'
        >
          See all inclusions
        </Button>
      )}
      {elementType === ElementType.Span && (
        <span
          className={cx([
            'text-base underline cursor-pointer font-light',
            'leading-3 hover:v2-text-neutral-900 v2-text-neutral-500',
          ])}
        >
          See all inclusions
        </span>
      )}
    </a>
  );
};

export default SeeAllInclusionsLink;
